'use strict';
angular.module('schoolLinqApp').factory('requestTypeService', [
	'$http',
	function ($http) {
		var endpoint = '/api/requesttype';

		function getRequestTypes() {
			return $http.get(endpoint + '/list');
		}

		function updateRequestTypes(requestTypes) {
			return $http.post(endpoint + '/updateRequestTypes', requestTypes);
		}

		function getRequestType(id) {
			return $http.get(endpoint + '/getRequestType', { params: { id: id } });
		}

		function addOrUpdateRequestType(requestType) {
			return $http.post(endpoint + '/addOrUpdateRequestType', requestType);
		}

		return {
			getRequestTypes: getRequestTypes,
			updateRequestTypes: updateRequestTypes,
			getRequestType: getRequestType,
			addOrUpdateRequestType: addOrUpdateRequestType,
		};
	},
]);
